import * as types from './user-settings.types';

export const userSettingsPageSelectors: types.IUserSettingsPageSelectors = {
  selectUserSettings: (state) => state.page.userSettings.userSettings,
  selectGoogleCalendarEmbedUrl: (state) => state.page.userSettings.userSettings.googleCalendarEmbedUrl,
  selectUserWidgets: (state) => state.page.userSettings.userSettings.widgets ?? [],
};
